<template>
  <section v-if="renderClosedApp" class="vn-curation__closed">
    <h2 class="vn-curation__h">모집 마감 강의</h2>

    <div class="vn-curation__select">
      <ul class="vn-card-closed">
        <li v-for="closedCourse in closedCoursesList" :key="closedCourse.id">
          <a :href="`/courses/${closedCourse.id}`" class="vn-card-closed__item">
            <div class="vn-card-closed__info">
              <div v-if="closedCourse.prerequisite" class="vn-card-closed__label">
                <span class="label label--name">{{ closedCourse.prerequisite }}</span>
              </div>

              <dl class="vn-card-ended__desc">
                <dt>{{ closedCourse.title }}</dt>
                <dd>{{ closedCourse.description }}</dd>
              </dl>
            </div>
          </a>
        </li>
      </ul>
    </div>

    <div class="btn-group">
      <button
        v-if="renderMoreButton"
        type="button"
        class="btn btn--lg btn--white vn-curation__more"
        @click="viewClosedCourses"
      >
        모집 마감 강의 더 보기
      </button>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'closed-course-app',
  props: ['formatId', 'categoryId'],
  computed: {
    ...mapState(['closedCourses']),
    renderClosedApp() {
      return this.closedCoursesList.length > 0;
    },
    renderMoreButton() {
      return this.pager < this.closedCourses.length;
    },
  },
  methods: {
    ...mapActions(['getClosedCourses']),
    viewClosedCourses() {
      this.pager += this.pagerCount;
      this.closedCoursesList = this.closedCourses.slice(0, this.pager);
    },
  },
  watch: {
    closedCourses() {
      this.viewClosedCourses();
    },
  },
  created() {
    const coursesData = {
      formatId: this.formatId,
      categoryId: this.categoryId,
    };

    this.$store.dispatch('getClosedCourses', coursesData);
  },
  updated() {},
  data() {
    return {
      pager: 0,
      pagerCount: 5,
      closedCoursesList: [],
    };
  },
};
</script>
